<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import store from "@/state/store";
import JsonExcel from "vue-json-excel";

export default {
  beforeRouteEnter(to, from, next) {
    const userType = store.getters["auth/getUser"].user_type;
    const permissions = store.getters["auth/permissions"];
    if (
      (userType === 1 || userType === 3) &&
      permissions.includes("APPROVE_PAYROLL")
    ) {
      next();
    } else {
      alert("You are not allowed to access this page. You will be redirected.");
      next("/");
    }
  },
  page: {
    title: "Approve Employee Emolument",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    JsonExcel,
  },
  async mounted() {
    await this.fetchPaymentDefinitions();
  },
  data() {
    return {
      title: "Approve Employee Emolument",
      items: [
        {
          text: "IHUMANE",
        },
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Approve Employee Emolument",
          active: true,
        },
      ],
      period: [],
      emoluments: [],
      filtered: [],
      newEmoluments: [],
      paymentDefinitions: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "sn",
      sortDesc: false,
      newFields: [
        "sn",
        "t7_number",
        "employeeName",
        "sector",
        "location",
        "jobRole",
        "salaryGrade",
        "contractStartDate",
        "contractEndDate",
      ],
      incomeFields: [],
      deductionFields: [],
      jsonFields: {},
      location: "N/A",
      payrollPeriod: "N/A",
      comment: null,
      unauthoriseComment: null,
    };
  },
  methods: {
    fetchPaymentDefinitions() {
      this.paymentDefinitions = [];
      const url = `${this.ROUTES.paymentDefinition}/employee-payment-definition`;
      this.apiGet(url, "Get Payment Definitions Error").then(async (res) => {
        const { data } = res;
        this.paymentDefinitions = data;
        await this.processFields(data);
        this.newFields.push(...this.incomeFields);
        this.newFields.push(...this.deductionFields);
        this.newFields.push("grossSalary");
        this.newFields.push("totalDeduction");
        this.newFields.push("netSalary");
        this.newFields.forEach((newField) => {
          if (newField === "sn") {
            this.jsonFields["S/N"] = newField;
          } else if (newField === "t7_number") {
            this.jsonFields["T7 NUMBER"] = "employeeUniqueId";
          } else if (newField === "employeeName") {
            this.jsonFields["EMPLOYEE NAME"] = newField;
          } else if (newField === "netSalary") {
            this.jsonFields["NET SALARY"] = newField;
          } else if (newField === "grossSalary") {
            this.jsonFields["GROSS SALARY"] = newField;
          } else if (newField === "totalDeduction") {
            this.jsonFields["TOTAL DEDUCTION"] = newField;
          } else {
            this.jsonFields[newField.toUpperCase()] = newField;
          }
        });
        await this.refreshTable();
      });
    },
    refreshTable() {
      let locationId = this.$route.params.locationId;
      const url = `${this.ROUTES.salary}/pull-emolument/${locationId}`;
      this.apiGet(url, "Generate Emolument Report").then(async (res) => {
        const { data } = res;
        console.log({ data });
        this.location = data?.[0].location;
        this.payrollPeriod = `${data?.[0].month}-${data?.[0].year}`;

        const newData = await this.sortArrayOfObjects(data);
        newData.forEach((emolument, index) => {
          let emolumentObj = {
            sn: ++index,
            employeeId: emolument.employeeId,
            employeeUniqueId: emolument.employeeUniqueId,
            employeeName: emolument.employeeName,
            location: emolument.location,
            sector: emolument.sector,
            jobRole: emolument.jobRole,
            salaryGrade: emolument.salaryGrade,
            contractStartDate: emolument.employeeStartDate,
            contractEndDate: emolument.empEndDate,
          };
          emolument.incomes.forEach((income) => {
            emolumentObj[income.paymentName] = this.apiValueHandler(
              income.amount.toFixed(2)
            );
          });
          emolument.deductions.forEach((deduction) => {
            emolumentObj[deduction.paymentName] = this.apiValueHandler(
              deduction.amount.toFixed(2)
            );
          });
          emolumentObj["grossSalary"] = this.apiValueHandler(
            emolument.grossSalary.toFixed(2)
          );
          emolumentObj["totalDeduction"] = this.apiValueHandler(
            emolument.totalDeduction.toFixed(2)
          );
          emolumentObj["netSalary"] = this.apiValueHandler(
            emolument.netSalary.toFixed(2)
          );
          this.newEmoluments.push(emolumentObj);
        });
        this.filtered = this.newEmoluments;
        this.totalRows = this.newEmoluments.length;
      });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.filtered = filteredItems;
      this.currentPage = 1;
    },
    async sortArrayOfObjects(array) {
      return array.sort(function (a, b) {
        let matchesA = a.employeeUniqueId.match(/(\d+)/);
        matchesA = parseInt(matchesA[0]);

        let matchesB = b.employeeUniqueId.match(/(\d+)/);
        matchesB = parseInt(matchesB[0]);

        return matchesA - matchesB;
      });
    },
    async processFields(data) {
      await data.forEach((paymentDefinition, index) => {
        if (paymentDefinition.pd_payment_type === 1) {
          this.incomeFields.push(data[index].pd_payment_name);
        } else if (paymentDefinition.pd_payment_type === 2) {
          this.deductionFields.push(data[index].pd_payment_name);
        }
      });
    },
    goBack() {
      this.$router.push({ name: "approve-payroll" });
    },
    approveRoutine() {
      if (!this.comment) {
        this.apiFormHandler(
          "A comment is required to approve payroll routine."
        );
        return;
      }

      const data = {
        pmyl_location_id: this.$route.params.locationId,
        pmyl_comment: this.comment,
      };
      const url = `${this.ROUTES.salary}/approve-salary-routine`;
      this.apiPost(url, data, "Approve Payroll Routine").then((res) => {
        this.$router
          .push({ name: "process-payroll" })
          .then(() =>
            this.apiResponseHandler(`${res.data}`, "Action Successful")
          );
      });
    },
    unauthoriseRoutine() {
      if (!this.unauthoriseComment) {
        this.apiFormHandler(
          "A comment is required to unauthorise payroll routine."
        );
        return;
      }

      const data = {
        pmyl_location_id: [this.$route.params.locationId],
        pmyl_comment: this.unauthoriseComment,
      };

      const url = `${this.ROUTES.salary}/unauthorise-salary-routine`;
      this.apiPost(url, data, "Unauthorise Salary Routine").then((res) => {
        this.$router
          .push({ name: "process-payroll" })
          .then(() =>
            this.apiResponseHandler(`${res.data}`, "Action Successful")
          );
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="d-flex justify-content-end mb-3">
      <b-button
        class="btn btn-success mr-2"
        @click="$refs['approve-routine'].show()"
        v-if="permissions.includes('APPROVE_PAYROLL')"
      >
        <i class="mdi mdi-check mr-2"></i>
        Approve Routine
      </b-button>
      <b-button
        class="btn btn-danger mr-2"
        @click="$refs['unauthorise-routine'].show()"
        v-if="permissions.includes('AUTHORISE_PAYROLL')"
      >
        <i class="mdi mdi-undo-variant mr-2"></i>
        Unauthorise Routine
      </b-button>
      <b-button class="btn btn-success mr-2" @click="goBack">
        <i class="mdi mdi-arrow-left mr-2"></i>
        Go Back
      </b-button>
    </div>
    <scale-loader v-if="apiBusy" />
    <div v-else class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="p-3 bg-light mb-4 d-flex justify-content-between">
              <h5 class="font-size-14 mb-0">
                Employee Emolument for Location: {{ location }} during Payroll
                Period: {{ payrollPeriod }}
              </h5>
              <span class="font-size-12 text-success">
                <JsonExcel
                  style="cursor: pointer"
                  :data="filtered"
                  :fields="jsonFields"
                  :name="`Emolument_Report(${payrollPeriod}_${location}).xls`"
                >
                  Export to Excel
                </JsonExcel>
              </span>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0" v-if="newEmoluments.length">
              <b-table
                selectable
                ref="emolument-table"
                bordered
                hover
                small
                :items="newEmoluments"
                :fields="newFields"
                striped
                responsive="lg"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                select-mode="single"
              >
                <template #cell(sn)="row">
                  <span>
                    {{ row.value }}
                  </span>
                </template>
                <template #cell(t7_number)="row">
                  <span>
                    {{ row.item.employeeUniqueId }}
                  </span>
                </template>
                <template #cell(employeeName)="row">
                  <span class="text-nowrap">
                    {{ row.value }}
                  </span>
                </template>
                <template #cell(sector)="row">
                  <span class="text-nowrap">
                    {{ row.value }}
                  </span>
                </template>
                <template #cell(location)="row">
                  <span class="text-nowrap">
                    {{ row.value }}
                  </span>
                </template>
                <template #cell(jobRole)="row">
                  <span class="text-nowrap">
                    {{ row.value }}
                  </span>
                </template>
                <template #cell()="data">
                  <span class="text-nowrap float-right">{{ data.value }}</span>
                </template>
                <template #cell(grossSalary)="row">
                  <span class="float-right">
                    {{ row.value }}
                  </span> </template
                ><template #cell(netSalary)="row">
                  <span class="float-right">
                    {{ row.value }}
                  </span>
                </template>
              </b-table>
            </div>
            <div v-else>
              <p class="text-center my-5">
                Populating report table, please wait...
              </p>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      ref="approve-routine"
      title="Approve Payroll Routine"
      hide-footer
      centered
      title-class="font-18"
    >
      <div class="modal-body p-1">
        <p>Are you sure you want to approve this payroll routine?</p>

        <label for="">Comment</label>
        <b-form-group>
          <textarea
            type="text"
            rows="4"
            class="form-control"
            v-model="comment"
          />
        </b-form-group>

        <b-button class="btn btn-success mt-2" @click="approveRoutine">
          <i class="mdi mdi-check mr-2"></i>
          Approve Routine
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="unauthorise-routine"
      title="Unauthorise Payroll Routine"
      hide-footer
      centered
      title-class="font-18"
    >
      <div class="modal-body p-1">
        <p>Are you sure you want to unauthorise this payroll routine?</p>

        <label for="">Comment</label>
        <b-form-group>
          <textarea
            type="text"
            rows="4"
            class="form-control"
            v-model="unauthoriseComment"
          />
        </b-form-group>

        <b-button class="btn btn-danger mt-2" @click="unauthoriseRoutine">
          <i class="mdi mdi-undo-variant mr-2"></i>
          Unauthorise Routine
        </b-button>
      </div>
    </b-modal>
  </Layout>
</template>
